
  const windowWidth = window.innerWidth;
  const spanElements = document.querySelectorAll('.announcement-text');
  const textContainer = document.querySelector('.announcement-text-container');
  let spanWidth = 0;
  // console.log("Window Width", windowWidth) 
  // console.log("Container Width",textContainer.offsetWidth);
  let originalTextContainerWidth = textContainer.offsetWidth;

  spanElements.forEach(span => {
    spanWidth += span.offsetWidth;
    // console.log(spanWidth)
  })

//   console.log('Width of spans', spanWidth) 
  
  let repeatedBy = Math.ceil(windowWidth / spanWidth);
//   console.log('Repeated X times',repeatedBy);

  for (let i = 0; i < repeatedBy; i++) {
    spanElements.forEach(span => {
      const clonedSpan = span.cloneNode(true);
      textContainer.appendChild(clonedSpan);
    });
  }

    // const styleSheets = document.styleSheets;
    // console.log(styleSheets)

    // for (let i = 0; i < styleSheets.length; i++) {
    //     const stylesheet = styleSheets[i];
    
    //     // Check if the stylesheet has an href property and includes the desired string
    //     if (stylesheet.href && stylesheet.href.includes('announcement-acro')) {
    //         // Check if the stylesheet is accessible (not blocked by cross-origin policies)
    //         if (!stylesheet.cssRules) {
    //             console.warn(`Cannot access stylesheet "${stylesheet.href}" due to cross-origin policies.`);
    //             continue;
    //         }
    
    //         stylesheet.insertRule(
    //             `@keyframes scrollAcro {
    //                 0% {
    //                   transform: translateX(0);
    //                 }
    //                 100% {
    //                   transform: translateX(-${textContainer.offsetWidth}px);
    //                 } 
    //             }`,
    //             stylesheet.cssRules.length
    //         );
    //     }
    // }

    // styleSheets.forEach(sheet => {
    // })

    const keyframes = `
    @keyframes scrollAcro {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(-${originalTextContainerWidth}px);
        }
    }`;

    // console.log(keyframes)

    const styleElement = document.createElement('style');
    styleElement.textContent = keyframes;

    document.head.appendChild(styleElement);
